// Data URI for a simple gray user silhouette (works without external files)
export const PLACEHOLDER_DATA_URI = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='%23555'/%3E%3Ccircle cx='50' cy='38' r='18' fill='%23888'/%3E%3Cellipse cx='50' cy='85' rx='30' ry='25' fill='%23888'/%3E%3C/svg%3E";

/**
 * Get the source URL for a user's profile photo
 * @param {Object} user - User object with profile_photo property
 * @param {string} preview - Optional preview URL (for upload preview)
 * @returns {string} Image source URL or data URI placeholder
 */
export function getProfilePhotoSrc(user, preview = null) {
    let photo = preview || user?.profile_photo;

    if (!photo || photo === 'null' || photo === 'undefined') {
        return PLACEHOLDER_DATA_URI;
    }
    if (photo.endsWith('.png') || photo.endsWith('.jpeg')) {
        photo = photo.replace(/\.(png|jpeg)$/i, '.jpg');
    }
    // Add cache-busting parameter to force browser to reload the image
    const timestamp = Date.now();
    return `${photo}?v=${timestamp}`;
}
